<!-- src/components/AboutUs.vue -->
		      <!-- <li><router-link to="/about/structure">发展历程</router-link></li> -->
<template>

	<div>
		<div class="banner">和优秀的人，做有挑战的事</div>
		
		<div class="about-us" style="width: 70%;text-align: center;margin-left: 15%;margin-top: 50px;">
		  <div class="sidebar">
		    <h2>公司概况</h2>
		    <ul>
		      <li><router-link to="/about/intro">公司简介</router-link></li>
		      <li><router-link to="/about/team">企业文化</router-link></li>
		      <li><router-link to="/about/culture">公司风貌</router-link></li>
		    </ul>
		  </div>
		  <div class="content">
		    <router-view></router-view>
		  </div>
		</div>
		
	</div>

</template>

<script>
export default {
  name: 'AboutUs'
};
</script>	

<style scoped>
	
.banner {
  height: 200px;
  line-height: 200px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../../assets/images/about.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}
	
.about-us {
  display: flex;
  flex-direction: column;
}

.sidebar {
  width: 100%;
  max-width: 250px;
  padding: 20px;
  background-color: #f4f4f4;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: max-width 0.3s;
}

.sidebar h2 {
  margin-bottom: 20px;
  font-size: 1.5em;
  color: #333;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar li {
  margin-bottom: 10px;
}

.sidebar li a {
  text-decoration: none;
  color: #333;
  padding: 10px;
  display: block;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.sidebar li a:hover {
  background-color: #e0e0e0;
}

.content {
  flex: 1;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: padding 0.3s;
}

@media (min-width: 768px) {
  .about-us {
    flex-direction: row;
  }

  .sidebar {
    width: 250px;
    padding: 40px 20px;
  }

  .content {
    padding: 40px;
  }
}
</style>
